import { IGetOfferDataParams, TGetOfferDataResult } from './types';
import { mapResponse200, mapResponse400 } from './utils';
import { fetchMobileGetContext, IMappers } from '../../repositories/monolith-python/v1/mobile-get-context';

export async function getOfferData(params: IGetOfferDataParams): Promise<TGetOfferDataResult> {
  const { httpApi, realtyOfferId, logger } = params;

  const parameters = {
    realtyId: realtyOfferId,
  };

  const mappers: IMappers<TGetOfferDataResult, null> = {
    200: mapResponse200,
    400: mapResponse400,
  };

  try {
    const result = await fetchMobileGetContext({ httpApi, parameters, mappers });

    return result as TGetOfferDataResult;
  } catch (error) {
    logger.debug('getOfferData error', { error, realtyOfferId });

    return null;
  }
}
